import { render, staticRenderFns } from "./prjAddProjectPropertyDialog.vue?vue&type=template&id=30416d4c"
import script from "./prjAddProjectPropertyDialog.vue?vue&type=script&lang=js"
export * from "./prjAddProjectPropertyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports